import React from 'react';
import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-cream-light" data-id="element-167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-170">
            La cruda realidad sobre la alimentación comercial
          </h2>
          <p className="text-lg text-gray-600" data-id="element-171">
            Lo que la industria no quiere que sepas sobre las croquetas
            tradicionales y cómo están acortando la vida de tu mascota.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-172">
          {/* Traditional Kibble Card */}
          <div className="bg-white rounded-3xl p-8 shadow-sm border border-red-100 relative overflow-hidden" data-id="element-173">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-400" data-id="element-174"></div>
            <div className="flex items-center mb-6" data-id="element-175">
              <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mr-4" data-id="element-176">
                <AlertTriangle className="w-6 h-6 text-red-500" data-id="element-177" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-178">
                Croquetas Tradicionales
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-179">
              {['Ingredientes ultra-procesados y subproductos', 'Altos niveles de carbohidratos innecesarios', 'Pérdida de nutrientes por cocción a altas temperaturas', 'Conservadores artificiales y colorantes', 'Mayor riesgo de obesidad y enfermedades crónicas'].map((item, i) => <li key={i} className="flex items-start" data-id="element-180">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-gray-600" data-id="element-182">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Bio-Vital Method Card */}
          <div className="bg-sage-light/10 rounded-3xl p-8 shadow-soft border border-sage-light relative overflow-hidden transform md:-translate-y-4" data-id="element-183">
            <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-184"></div>
            <div className="flex items-center mb-6" data-id="element-185">
              <div className="w-12 h-12 rounded-full bg-sage-light/30 flex items-center justify-center mr-4" data-id="element-186">
                <CheckCircle2 className="w-6 h-6 text-sage-dark" data-id="element-187" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-188">
                Método Bio-Vital
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-189">
              {['Ingredientes biológicamente apropiados', 'Balance perfecto de proteínas y grasas saludables', 'Máxima absorción de nutrientes naturales', 'Libre de químicos y aditivos tóxicos', 'Sistema inmunológico fuerte y mayor longevidad'].map((item, i) => <li key={i} className="flex items-start" data-id="element-190">
                  <CheckCircle2 className="w-5 h-5 text-sage-dark mr-3 shrink-0 mt-0.5" data-id="element-191" />
                  <span className="text-gray-800 font-medium" data-id="element-192">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}